<div class='gov-file-uploader' [ngClass]='{ "is-invalid": isInvalid() }'>
  <div class='gov-file-uploader__header' *ngIf='!readonly'>

  </div>
  <div class='gov-file-uploader__input' *ngIf='!readonly'>
    <input
      [multiple]='multiple'
      [disabled]='disabled || (!canAdd)'
      (change)='onInputChange($event); fileInput.value = ""'
      #fileInput
      id='files'
      name='files'
      type='file'
      [accept]='accept'
      tabindex='-1'>
    <p>Przeciągnij i upuść pliki na to pole<br />
      albo załaduj z dysku.</p>
    <button
      [disabled]='disabled || (!canAdd)'
      (click)='fileInput.click()'
      type='button'
      class='btn btn-secondary'>
      <span>Dodaj plik</span>
    </button>
    <p class='info'>
      Dopuszczalne formaty plików: {{ accept }}
      <br />
      @if (overSizeError) {
        <strong class="oversize-error">Rozmiar pliku jest zbyt duży! (Maks:20Mb)</strong>
      } @else {
        <strong>Maksymalny rozmiar {{ maxFileSize }}Mb</strong>
      }
    </p>
  </div>
  <div class='gov-file-uploader__files-list'>
    <ol class="ps-3">
      <li *ngFor='let item of attachments(); let i = index'>
        <a href="#" [attr.aria-label]="'Pobierz: ' + item?.originalName" (click)="download($event, item)">{{ item?.customName || item?.originalName }}</a><br />
        <span>{{ item?.fileSize | fileSize }}</span>
        <div class='error__message'>
          Błąd podczas dodawania pliku
        </div>
        <button
          *ngIf='!disabled && !readonly'
          title='Usuń'
          (click)='onRemove(i)'
          type='button'
          aria-label='Usuń'>
        </button>
      </li>
    </ol>
  </div>
</div>
